<aside
  *transloco="let t"
  class="flex h-full w-50 flex-col bg-surface text-base-content border-r border-border-default"
>
  <div
    class="flex h-14 shrink-0 items-center gap-2 px-3 border-b border-border-default"
  >
    <svg
      class="w-5 h-5 text-primary"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.5" />
      <text x="12" y="5" text-anchor="middle" font-size="3" fill="currentColor" font-weight="bold">N</text>
      <polygon points="12,4 14,12 12,14 10,12" fill="currentColor" />
      <polygon points="12,20 14,12 12,10 10,12" fill="currentColor" opacity="0.4" />
    </svg>
    <h1 class="text-heading-sm truncate">{{ t('nav.appTitle') }}</h1>
  </div>

  <nav class="flex-1 overflow-y-auto py-2">
    <ul class="w-full flex flex-col">
      @for (item of menuItems(); track item.id) {
        @if (item.disabled) {
          <li
            class="opacity-40 cursor-not-allowed"
            [title]="t(item.labelKey) + ' — ' + t('nav.comingSoon')"
          >
            <span class="nav-item pointer-events-none">
              <fa-icon [icon]="item.icon" class="option-row__icon" aria-hidden="true" />
              {{ t(item.labelKey) }}
            </span>
          </li>
        } @else if (item.children) {
          <li class="flex flex-col">
            <span class="nav-group-label mt-3 mb-1 flex items-center gap-2">
              <fa-icon [icon]="item.icon" class="option-row__icon" aria-hidden="true" />
              {{ t(item.labelKey) }}
            </span>
            <ul class="flex flex-col">
              @for (child of item.children; track child.id) {
                <li>
                  <a
                    class="nav-item pl-9"
                    [routerLink]="child.route"
                    routerLinkActive="nav-item--active"
                    >{{ t(child.labelKey) }}</a
                  >
                </li>
              }
            </ul>
          </li>
        } @else {
          <li>
            <a
              class="nav-item"
              [routerLink]="item.route"
              routerLinkActive="nav-item--active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <fa-icon [icon]="item.icon" class="option-row__icon" aria-hidden="true" />
              {{ t(item.labelKey) }}
            </a>
          </li>
        }
      }
    </ul>
  </nav>

  <div class="shrink-0 px-3 py-2 border-t border-border-default">
  </div>

  @if (profile(); as userProfile) {
    <div class="shrink-0 p-3 border-t border-border-default">
      <div class="flex items-center gap-2">
        <div class="avatar avatar-placeholder">
          <div class="bg-unifi-blue-07 text-white w-6 rounded-full">
            <span class="text-caption">{{ userProfile | initials }}</span>
          </div>
        </div>

        <div class="flex-1 min-w-0">
          <p class="text-caption font-semibold truncate m-0">
            {{ userProfile | fullName }}
          </p>
          <p class="text-caption text-text-secondary truncate m-0">
            {{ userProfile.role | userRole }}
          </p>
        </div>

        <a
          routerLink="/settings/profile"
          routerLinkActive="text-text-link"
          [attr.aria-label]="t('nav.profileSettings')"
          appButton="ghost"
          size="sm"
          shape="square"
        >
          <fa-icon [icon]="settingsIcon" aria-hidden="true" />
        </a>

        <button
          type="button"
          (click)="onLogout()"
          [attr.aria-label]="t('auth.logout')"
          appButton="ghost"
          size="sm"
          shape="square"
          class="!text-error-text"
        >
          <fa-icon [icon]="logoutIcon" aria-hidden="true" />
        </button>
      </div>
    </div>
  }

  <div class="shrink-0 px-3 py-2 text-center border-t border-border-default">
    <p class="text-caption text-text-secondary">
      Version {{ version() }} ({{
        environmentName() | environmentLevel | titlecase
      }})
    </p>
  </div>
</aside>
